// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2tWE2","actionColumn":"ReferralSources_actionColumn__ZIY7F","textButton":"ReferralSources_textButton__6-lYu"};